import ArrowRightIcon from '../../assets/icons/ArrowRight.tsx';
import MailLetterIcon from '../../assets/icons/MailLetter';
import AlertCircleIcon from '../../assets/icons/AlertCircle';
import MobileAppIcon from '../../assets/icons/MobileApp';
import WebAppIcon from '../../assets/icons/WebApp';
import UsersIcon from '../../assets/icons/Users.tsx';
import DevicesIcon from '../../assets/icons/Devices.tsx';
import CommunicationIcon from '../../assets/icons/Communication.tsx';
import EarningsIcon from '../../assets/icons/Earnings.tsx';
import SpeedUpIcon from '../../assets/icons/SpeedUp.tsx';
import EfficiencyIcon from '../../assets/icons/Efficiency.tsx';
import CheckIcon from '../../assets/icons/Check.tsx';
import TwitterIcon from '../../assets/icons/Twitter.tsx';
import LinkedInIcon from '../../assets/icons/LinkedIn.tsx';
import FacebookIcon from '../../assets/icons/Facebook.tsx';
import BeApproachableIcon from '../../assets/icons/BeApproachable.tsx';
import CalendarIcon from '../../assets/icons/Calendar.tsx';
import SearchIcon from '../../assets/icons/Search.tsx';
import ContractIcon from '../../assets/icons/Contract.tsx';
import DocumentIcon from '../../assets/icons/Document.tsx';
import UserIcon from '../../assets/icons/User.tsx';
import CloseIcon from '../../assets/icons/Close.tsx';
import MenuIcon from '../../assets/icons/Menu.tsx';
import XCircleIcon from '../../assets/icons/XCircle.tsx';
import LockIcon from '../../assets/icons/Lock.tsx';
import EyeHideIcon from '../../assets/icons/EyeHide.tsx';
import EyeShowIcon from '../../assets/icons/EyeShow.tsx';
import ArrowLeftIcon from '../../assets/icons/ArrowLeft.tsx';
import ChevronDownIcon from '../../assets/icons/ChevronDown.tsx';
import Users2Icon from '../../assets/icons/Users2.tsx';
import ClipboardIcon from '../../assets/icons/Clipboard.tsx';
import GeoPointIcon from '../../assets/icons/GeoPoint.tsx';
import LocationIcon from '../../assets/icons/Location.tsx';
import UKFlagIcon from '../../assets/icons/UKFlag.tsx';
import IrelandFlagIcon from '../../assets/icons/IrelandFlag.tsx';
import CameraIcon from '../../assets/icons/Camera.tsx';
import RefreshIcon from '../../assets/icons/Refresh.tsx';
import TrashIcon from '../../assets/icons/Trash.tsx';
import UploadIcon from '../../assets/icons/Upload.tsx';
import LogOutIcon from '../../assets/icons/LogOut.tsx';
import CircleCheckFilledIcon from '../../assets/icons/CircleCheckFilled.tsx';
import CircleCheckOutlinedIcon from '../../assets/icons/CircleCheckOutlined.tsx';
import NotifyBellIcon from '../../assets/icons/NotifyBell.tsx';
import ApplicationsIcon from '../../assets/icons/Applications.tsx';
import CompaniesIcon from '../../assets/icons/Companies.tsx';
import DotsVerticalIcon from '../../assets/icons/DotsVertical.tsx';
import SettingsIcon from '../../assets/icons/Settings.tsx';
import InfoIcon from '../../assets/icons/Info.tsx';
import DeactivateIcon from '../../assets/icons/Deactivate.tsx';
import ActivateIcon from '../../assets/icons/Activate.tsx';
import PlusIcon from '../../assets/icons/Plus.tsx';
import WarningIcon from '../../assets/icons/Warning.tsx';
import EditIcon from '../../assets/icons/Edit.tsx';
import CopyIcon from '../../assets/icons/Copy.tsx';
import MinusIcon from '../../assets/icons/Minus.tsx';
import MarkerIcon from '../../assets/icons/Marker.tsx';
import NotesIcon from '../../assets/icons/Notes.tsx';
import LiveIcon from '../../assets/icons/Live.tsx';
import OngoingIcon from '../../assets/icons/Ongoing.tsx';
import CompletedIcon from '../../assets/icons/Completed.tsx';
import OnHoldIcon from '../../assets/icons/OnHold.tsx';
import UnfulfilledIcon from '../../assets/icons/Unfulfilled.tsx';
import DraftIcon from '../../assets/icons/Draft.tsx';
import PoundIcon from '../../assets/icons/Pound.tsx';
import DotIcon from '../../assets/icons/Dot.tsx';
import RateIcon from '../../assets/icons/Rate.tsx';
import AttachIcon from '../../assets/icons/Attach.tsx';
import SendIcon from '../../assets/icons/Send.tsx';
import PdfIcon from '../../assets/icons/Pdf.tsx';
import DocIcon from '../../assets/icons/Doc.tsx';
import DocxIcon from '../../assets/icons/Docx.tsx';
import CheckDoubleIcon from '../../assets/icons/CheckDouble.tsx';
import DownloadIcon from '../../assets/icons/Download.tsx';
import TxtIcon from '../../assets/icons/Txt.tsx';
import RtfIcon from '../../assets/icons/Rtf.tsx';
import OdtIcon from '../../assets/icons/Odt.tsx';
import ZipIcon from '../../assets/icons/Zip.tsx';
import RarIcon from '../../assets/icons/Rar.tsx';
import SevenZipIcon from '../../assets/icons/7z.tsx';
import TarIcon from '../../assets/icons/tar.tsx';
import InfoFilledIcon from '../../assets/icons/InfoFilled.tsx';
import GeneralFileIcon from '../../assets/icons/GeneralFile.tsx';
import WarningOutlineIcon from '../../assets/icons/WarningOutline.tsx';
import GridIcon from '../../assets/icons/Grid.tsx';
import DynamicArrowIcon from '../../assets/icons/DynamicArrow.tsx';
import FilledQuestionIcon from '../../assets/icons/FilledQuestion.tsx';
import QuestionOutlinedIcon from '../../assets/icons/QuestionOutlined.tsx';
import MaximizeIcon from '../../assets/icons/Maximize.tsx';
import MinimizeIcon from '../../assets/icons/Minimize.tsx';
import CloseCircleIcon from '../../assets/icons/CloseCircle.tsx';
import XlsxIcon from '../../assets/icons/Xlsx.tsx';
import CsvIcon from '../../assets/icons/Csv.tsx';
import XlsIcon from '../../assets/icons/Xls.tsx';
import ClockIcon from '../../assets/icons/Clock.tsx';
import ExclamationIcon from '../../assets/icons/Exclamation.tsx';
import ExclamationFilledIcon from '../../assets/icons/ExclamationFilled.tsx';
import MinusCircleIcon from '../../assets/icons/MinusCircle.tsx';
import ContractCompleteIcon from '../../assets/icons/ContractComplete.tsx';
import FeedbackIcon from '../../assets/icons/Feedback.tsx';
import PinIcon from '../../assets/icons/Pin.tsx';
import MoonIcon from '../../assets/icons/Moon.tsx';
import SunIcon from '../../assets/icons/Sun.tsx';
import HotIcon from '../../assets/icons/Hot.tsx';

export enum IconKeys {
  ArrowRight = 'arrow-right',
  ArrowLeft = 'arrow-left',
  ChevronDown = 'chevron-down',
  MailLetter = 'mail-letter',
  AlertCircle = 'alert-circle',

  MobileApp = 'mobile-app',
  WebApp = 'web-app',

  Users = 'users',
  Users2 = 'users-2',
  Devices = 'devices',
  Communication = 'communication',
  Earnings = 'earnings',
  SpeedUp = 'speed-up',
  Efficiency = 'efficiency',

  Check = 'check',

  Twitter = 'twitter',
  LinkedIn = 'linked-in',
  Facebook = 'facebook',

  BeApproachable = 'be-approachable',
  Calendar = 'calendar',
  Search = 'search',
  Contract = 'contract',
  Document = 'document',
  User = 'user',
  Close = 'close',
  Menu = 'menu',
  XCircle = 'x-circle',
  Lock = 'lock',
  EyeHide = 'eye-hide',
  EyeShow = 'eye-show',
  Clipboard = 'clipboard',
  GeoPoint = 'Geo-point',
  Location = 'location',
  UKFlag = 'UKFlag',
  IrelandFlag = 'IrelandFlag',
  Camera = 'camera',
  Refresh = 'Refresh',
  Trash = 'Trash',
  Upload = 'Upload',
  LogOut = 'LogOut',
  CircleCheckFilled = 'CircleCheckFilled',
  CircleCheckOutlined = 'CircleCheckOutlined',
  NotifyBell = 'NotifyBell',
  Applications = 'Applications',
  Companies = 'Companies',
  DotsVertical = 'DotsVertical',
  Settings = 'Settings',
  Info = 'Info',
  Deactivate = 'Deactivate',
  Activate = 'Activate',
  Plus = 'Plus',
  Warning = 'Warning',
  Edit = 'Edit',
  Copy = 'Copy',
  Minus = 'Minus',
  Marker = 'Marker',
  Notes = 'Notes',
  Draft = 'Draft',
  Live = 'Live',
  Ongoing = 'Ongoing',
  Completed = 'Completed',
  OnHold = 'OnHold',
  Unfulfilled = 'Unfulfilled',
  Pound = 'Pound',
  Dot = 'Dot',
  Rate = 'Rate',
  Attach = 'Attach',
  Send = 'Send',
  'application/pdf' = 'application/pdf',
  'application/msword' = 'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document' = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'video/mp4' = 'video/mp4',
  'application/vnd.ms-excel' = 'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/csv' = 'text/csv',
  'mov' = 'video/quicktime',
  CheckDouble = 'CheckDouble',
  Download = 'Download',
  Txt = 'text/plain',
  Rtf = 'application/rtf',
  Odt = 'application/vnd.oasis.opendocument.text',
  Zip = 'application/zip',
  ZipWindows = 'application/x-zip-compressed',
  Rar = 'application/vnd.rar',
  SevenZip = 'application/x-7z-compressed',
  Tar = 'application/x-tar',
  InfoFilled = 'InfoFilled',
  GeneralFile = 'GeneralFile',
  WarningOutline = 'WarningOutline',
  Grid = 'Grid',
  DynamicArrow = 'DynamicArrow',
  FilledQuestion = 'FilledQuestion',
  QuestionOutlined = 'QuestionOutlined',
  Maximize = 'Maximize',
  Minimize = 'Minimize',
  CloseCircle = 'CloseCircle',
  Clock = 'Clock',
  Exclamation = 'Exclamation',
  MinusCircle = 'MinusCircle',
  ContractComplete = 'ContractComplete',
  Feedback = 'Feedback',
  Pin = 'Pin',
  Moon = 'Moon',
  Sun = 'Sun',
  ExclamationFilled = 'ExclamationFilled',
  Hot = 'Hot',
}

export const FileIconStreamChat = {
  [IconKeys['application/pdf']]: PdfIcon,
  [IconKeys['application/msword']]: DocIcon,
  [IconKeys['application/vnd.openxmlformats-officedocument.wordprocessingml.document']]: DocxIcon,
  [IconKeys.Txt]: TxtIcon,
  [IconKeys.Rtf]: RtfIcon,
  [IconKeys.Odt]: OdtIcon,
  [IconKeys.Zip]: ZipIcon,
  [IconKeys.ZipWindows]: ZipIcon,
  [IconKeys.Rar]: RarIcon,
  [IconKeys.SevenZip]: SevenZipIcon,
  [IconKeys.Tar]: TarIcon,
  [IconKeys['video/mp4']]: GeneralFileIcon,
  [IconKeys['application/vnd.ms-excel']]: XlsIcon,
  [IconKeys['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']]: XlsxIcon,
  [IconKeys['text/csv']]: CsvIcon,
  [IconKeys.mov]: GeneralFileIcon,
  [IconKeys.GeneralFile]: GeneralFileIcon,
};

export const IconComponents = {
  [IconKeys.ArrowRight]: ArrowRightIcon,
  [IconKeys.ArrowLeft]: ArrowLeftIcon,
  [IconKeys.ChevronDown]: ChevronDownIcon,

  [IconKeys.MailLetter]: MailLetterIcon,
  [IconKeys.AlertCircle]: AlertCircleIcon,

  [IconKeys.MobileApp]: MobileAppIcon,
  [IconKeys.WebApp]: WebAppIcon,

  [IconKeys.Users]: UsersIcon,
  [IconKeys.Users2]: Users2Icon,
  [IconKeys.Devices]: DevicesIcon,
  [IconKeys.Communication]: CommunicationIcon,
  [IconKeys.Earnings]: EarningsIcon,
  [IconKeys.SpeedUp]: SpeedUpIcon,
  [IconKeys.Efficiency]: EfficiencyIcon,

  [IconKeys.Check]: CheckIcon,

  [IconKeys.Twitter]: TwitterIcon,
  [IconKeys.LinkedIn]: LinkedInIcon,
  [IconKeys.Facebook]: FacebookIcon,

  [IconKeys.BeApproachable]: BeApproachableIcon,
  [IconKeys.Calendar]: CalendarIcon,
  [IconKeys.Search]: SearchIcon,
  [IconKeys.Contract]: ContractIcon,
  [IconKeys.Document]: DocumentIcon,
  [IconKeys.User]: UserIcon,
  [IconKeys.Close]: CloseIcon,
  [IconKeys.Menu]: MenuIcon,
  [IconKeys.XCircle]: XCircleIcon,
  [IconKeys.Lock]: LockIcon,
  [IconKeys.EyeHide]: EyeHideIcon,
  [IconKeys.EyeShow]: EyeShowIcon,
  [IconKeys.Clipboard]: ClipboardIcon,
  [IconKeys.GeoPoint]: GeoPointIcon,
  [IconKeys.Location]: LocationIcon,
  [IconKeys.UKFlag]: UKFlagIcon,
  [IconKeys.IrelandFlag]: IrelandFlagIcon,
  [IconKeys.Camera]: CameraIcon,
  [IconKeys.Refresh]: RefreshIcon,
  [IconKeys.Trash]: TrashIcon,
  [IconKeys.Upload]: UploadIcon,
  [IconKeys.LogOut]: LogOutIcon,
  [IconKeys.CircleCheckFilled]: CircleCheckFilledIcon,
  [IconKeys.CircleCheckOutlined]: CircleCheckOutlinedIcon,
  [IconKeys.NotifyBell]: NotifyBellIcon,
  [IconKeys.Applications]: ApplicationsIcon,
  [IconKeys.Companies]: CompaniesIcon,
  [IconKeys.DotsVertical]: DotsVerticalIcon,
  [IconKeys.Settings]: SettingsIcon,
  [IconKeys.Info]: InfoIcon,
  [IconKeys.Deactivate]: DeactivateIcon,
  [IconKeys.Activate]: ActivateIcon,
  [IconKeys.Plus]: PlusIcon,
  [IconKeys.Warning]: WarningIcon,
  [IconKeys.Edit]: EditIcon,
  [IconKeys.Copy]: CopyIcon,
  [IconKeys.Minus]: MinusIcon,
  [IconKeys.Marker]: MarkerIcon,
  [IconKeys.Notes]: NotesIcon,
  [IconKeys.Draft]: DraftIcon,
  [IconKeys.Live]: LiveIcon,
  [IconKeys.Ongoing]: OngoingIcon,
  [IconKeys.Completed]: CompletedIcon,
  [IconKeys.OnHold]: OnHoldIcon,
  [IconKeys.Unfulfilled]: UnfulfilledIcon,
  [IconKeys.Pound]: PoundIcon,
  [IconKeys.Dot]: DotIcon,
  [IconKeys.Rate]: RateIcon,
  [IconKeys.Attach]: AttachIcon,
  [IconKeys.Send]: SendIcon,
  ...FileIconStreamChat,
  [IconKeys.CheckDouble]: CheckDoubleIcon,
  [IconKeys.Download]: DownloadIcon,
  [IconKeys.InfoFilled]: InfoFilledIcon,
  [IconKeys.WarningOutline]: WarningOutlineIcon,
  [IconKeys.Grid]: GridIcon,
  [IconKeys.DynamicArrow]: DynamicArrowIcon,
  [IconKeys.FilledQuestion]: FilledQuestionIcon,
  [IconKeys.QuestionOutlined]: QuestionOutlinedIcon,
  [IconKeys.Maximize]: MaximizeIcon,
  [IconKeys.Minimize]: MinimizeIcon,
  [IconKeys.CloseCircle]: CloseCircleIcon,
  [IconKeys.Clock]: ClockIcon,
  [IconKeys.Exclamation]: ExclamationIcon,
  [IconKeys.MinusCircle]: MinusCircleIcon,
  [IconKeys.ContractComplete]: ContractCompleteIcon,
  [IconKeys.Feedback]: FeedbackIcon,
  [IconKeys.Pin]: PinIcon,
  [IconKeys.Moon]: MoonIcon,
  [IconKeys.Sun]: SunIcon,
  [IconKeys.ExclamationFilled]: ExclamationFilledIcon,
  [IconKeys.Hot]: HotIcon,
};
